import React, { useRef, useEffect } from 'react';
import { faFolderOpen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PropTypes } from 'prop-types';

import { Content, Header, Scrollbox, ModalContainer } from './styles';

const propTypes = {
    show: PropTypes.bool,
    title: PropTypes.string,
}
const Modal = ({ visible, setVisible, title, children }) => {
    const myRef = useRef();

    const handleClickOutside = e => {
        if (!myRef.current.contains(e.target)) {
            setVisible(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    });

    return (
        <ModalContainer show={visible}>
            <Content ref={myRef}>
                {title ?
                    <Header>
                        {title}
                    </Header>
                    : ""
                }
                {/* <FontAwesomeIcon icon={faFolderOpen} size="lg" color="#FFF" /> */}
                <Scrollbox>
                    {children}
                </Scrollbox>
            </Content>
        </ModalContainer>
    )
}
Modal.propTypes = propTypes;
export default Modal;